// source: starlord/messages/request/application_assignment_unassignment_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.ApplicationAssignmentOrUnassignmentRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.ApplicationAssignmentOrUnassignmentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.ApplicationAssignmentOrUnassignmentRequest.repeatedFields_, null);
};
goog.inherits(proto.ApplicationAssignmentOrUnassignmentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.ApplicationAssignmentOrUnassignmentRequest.displayName = 'proto.ApplicationAssignmentOrUnassignmentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.ApplicationAssignmentOrUnassignmentRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.ApplicationAssignmentOrUnassignmentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplicationAssignmentOrUnassignmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationAssignmentOrUnassignmentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    applicationid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    useridsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    groupidsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.ApplicationAssignmentOrUnassignmentRequest;
  return proto.ApplicationAssignmentOrUnassignmentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplicationAssignmentOrUnassignmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserids(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.ApplicationAssignmentOrUnassignmentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplicationAssignmentOrUnassignmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.ApplicationAssignmentOrUnassignmentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplicationid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUseridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getGroupidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * optional string tenantId = 1;
 * @return {string}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string applicationId = 2;
 * @return {string}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.getApplicationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.setApplicationid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string userIds = 3;
 * @return {!Array<string>}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.getUseridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.setUseridsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.addUserids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.clearUseridsList = function() {
  return this.setUseridsList([]);
};


/**
 * repeated string groupIds = 4;
 * @return {!Array<string>}
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.getGroupidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.setGroupidsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.addGroupids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ApplicationAssignmentOrUnassignmentRequest} returns this
 */
proto.ApplicationAssignmentOrUnassignmentRequest.prototype.clearGroupidsList = function() {
  return this.setGroupidsList([]);
};


goog.object.extend(exports, proto);
